import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { PublicLanguage } from './content';

export function usePublicLanguage(): PublicLanguage {
  const { pathname } = useLocation();
  const { i18n } = useTranslation();
  const explicit = pathname.match(/^\/(fr|en)(?:\/|$)/)?.[1];
  return (explicit || (i18n.language.startsWith('fr') ? 'fr' : 'en')) as PublicLanguage;
}
